// extracted by mini-css-extract-plugin
module.exports = {"Product":"Product_Product__2vNml","ProductPanel":"Product_ProductPanel__2l0Ov"};